export const initJobs = function (config) {
  $('.flixx_jobs').each(function () {
    let
      $elJobs = $(this),
      $elJobsFilterCountry = $elJobs.find('.filter-country'),
      $elJobsFilterCompany = $elJobs.find('.filter-company'),
      $elCount = $elJobs.find('.count'),
      $items = $elJobs.find('.items > .item'),
      filterCompany = [],
      filterCountry = []
    ;

    $items.each(function () {
      filterCompany.push($(this).attr('data-filter-company'));
      filterCountry.push($(this).attr('data-filter-country'));
    });

    // remove duplicates
    filterCompany = [...new Set(filterCompany)];
    filterCountry = [...new Set(filterCountry)];

    // set filter options
    for (let i = 0; i < filterCompany.length; ++i) {
      $elJobsFilterCompany.append($('<option>', {
        value: filterCompany[i],
        text: filterCompany[i]
      }));
    }
    for (let i = 0; i < filterCountry.length; ++i) {
      $elJobsFilterCountry.append($('<option>', {
        value: filterCountry[i],
        text: filterCountry[i]
      }));
    }

    // set initial counter
    $elCount.text($elJobs.find('.items > .item:not(.d-none)').length);

    $elJobsFilterCompany.on('change', function() {

      // reset other select
      $elJobsFilterCountry.prop('selectedIndex',0);

      let value = this.value;
      $items.each(function(){
        $(this).removeClass('d-none');
        if ((value != 'reset') && ($(this).attr('data-filter-company') != value)){
          $(this).addClass('d-none');
        }
      });

      $elCount.text($elJobs.find('.items > .item:not(.d-none)').length);
    });

    $elJobsFilterCountry.on('change', function() {

      // reset other select
      $elJobsFilterCompany.prop('selectedIndex',0);

      let value = this.value;
      $items.each(function(){
        $(this).removeClass('d-none');
        if ((value != 'reset') && ($(this).attr('data-filter-country') != value)){
          $(this).addClass('d-none');
        }
      });

      $elCount.text($elJobs.find('.items > .item:not(.d-none)').length);
    });
  });


}
